import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {IconButton, Grid, Typography, Link, Paper} from '@material-ui/core';
import {Modal, Fade, Backdrop} from '@material-ui/core';
import {CircleInfoPopout} from 'components/icons/icons';
import CloseIcon from '@material-ui/icons/Close';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import {PBold} from 'components/TypographyShortcuts';
import FluidVideo from 'components/FluidVideo';

const useStyles = makeStyles(theme => ({
    root: {
        [theme.breakpoints.down('sm')]: {
            width: '20em',
            height: '15em',
        },
        [theme.breakpoints.up('md')]: {
            width: '40em',
            height: '30em',
        },
    },
    cardcontent: {
        paddingTop: '0',
    },
    image: {
        maxWidth: '40em',
    },
    modalGrid: {
        display: '',
        padding: '.3em',
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        outline: 'none',
    },
    backdrop: {
        backdropFilter: 'blur(5px)',
    },

    paper: {
        padding: '1rem',
        margin: 'auto',
        maxWidth: 1000,
    },
    videobox: {
        aspectRatio: '16/9',
    },
}));

//To add InfoModal to a component, import InfoModal from here and content from InfoModalContent,
//In InfoModalContent, name your content object (for example mmcrefnum) and specify title, text, etc.
//Then add it inside the component like this <InfoModal content={content.mmcrefnum}/>

const InfoModal = ({content, infoModalPadding}) => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    if (content) {
        const {title, video_embed_url, image_file, text, link_url, link_label} =
            content;

        const hasData =
            title?.length ||
            video_embed_url?.length ||
            image_file?.length ||
            text?.length ||
            link_url?.length ||
            link_label?.length;

        if (hasData) {
            return (
                <>
                    <Grid item className={classes.modalGrid}>
                        <IconButton
                            variant='extended'
                            edge='end'
                            size='small'
                            color='secondary'
                            aria-label='support'
                            onClick={handleOpen}
                        >
                            <CircleInfoPopout />
                        </IconButton>
                    </Grid>
                    <Modal
                        className={classes.modal}
                        open={open}
                        onClose={handleClose}
                        closeAfterTransition
                        outline='none'
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                            className: classes.backdrop,
                        }}
                    >
                        <Fade in={open}>
                            <Paper className={classes.paper}>
                                <CardActionArea>
                                    <CardContent
                                        className={classes.cardcontent}
                                    >
                                        <Grid
                                            container
                                            direction='row'
                                            justifyContent='flex-end'
                                            alignItems='flex-start'
                                            style={{height: '.6rem'}}
                                        >
                                            <IconButton
                                                color='primary'
                                                aria-label='close'
                                                edge='end'
                                                onClick={handleClose}
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                        </Grid>
                                        <Typography>
                                            <PBold
                                                gutterBottom
                                                variant='h5'
                                                component='h2'
                                            >
                                                {title}
                                            </PBold>
                                        </Typography>
                                    </CardContent>
                                    <CardContent
                                        className={classes.cardcontent}
                                    >
                                        {image_file ? (
                                            <CardMedia
                                                component='img'
                                                alt='img'
                                                className={classes.image}
                                                image={image_file}
                                                title='Info Image'
                                            />
                                        ) : null}
                                        {video_embed_url ? (
                                            <FluidVideo
                                                data={video_embed_url}
                                                title='YouTube Video'
                                            />
                                        ) : null}
                                        <Typography
                                            variant='body2'
                                            component='p'
                                            style={{marginTop: '1em'}}
                                        >
                                            {text}
                                        </Typography>
                                        <Link
                                            href={link_url}
                                            target='_blank'
                                            rel='noopener'
                                            variant='body1'
                                        >
                                            {link_label}
                                        </Link>
                                    </CardContent>
                                </CardActionArea>
                            </Paper>
                        </Fade>
                    </Modal>
                </>
            );
        } else {
            return <></>;
        }
    } else {
        return <></>;
    }
};

export default InfoModal;
